<template>
	<div class="indexView">
		<el-container>
			<el-main>
				<HeaderRow selUrl="student"></HeaderRow>
				<div class="banner" v-if="navList[2]&&navList[2].icon_image">
					<el-image style="width: 100%; height: 300px" fit="cover" :src="navList[2].icon_image"></el-image>
				</div>
				<div class="breadcrumb">
					<div class="backItem" @click="()=>$router.back()"><i class="el-icon-arrow-left">返回</i></div>
					<el-breadcrumb separator="/">
						<el-breadcrumb-item to="/">首页</el-breadcrumb-item>
						<el-breadcrumb-item to="/student">学员优作</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="worksDiv">
					<div class="worksItem" v-for="group in groupList" :key="group.id">
						<div class="title" @click="gotoStList(group)">
							<span>{{ group.group_name }}</span>
							<i class="el-icon-arrow-right"></i>
						</div>
						<div v-if="group.list&&group.list.length">
							<div class="first" @click="gotoStDetail(group, group.list[0])">
								<img v-if="group.list[0].images" :src="group.list[0].images" />
								<img v-else :src="require('@/assets/student/pic.png')" />
								<div class="info">
									<p>{{ group.list[0].title }}</p>
									<p v-html="group.list[0].content"></p>
								</div>
							</div>
							<div class="row" v-for="(row,index) in group.list" :key="row.id" @click="gotoStDetail(group, row)"
								:style="{display:index===0||index>=5?'none':'block'}">
								<p>
									{{ row.title }}
								</p>
							</div>
						</div>
						<el-empty v-else description="此分类暂无数据" :image-size="72"></el-empty>
					</div>
				</div>
				<FooterRow></FooterRow>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import indexjs from "./index.js";
	import {
		copy
	} from "clipboard";
	import HeaderRow from "@/components/headerRow.vue";
	import FooterRow from "@/components/footerRow.vue";

	export default {
		methods: {
			copy,
		},
		...indexjs,
		components: {
			HeaderRow,
			FooterRow,
		},
		computed: {},

	};
</script>

<style lang="scss" scoped>
	@import "./index.scss";
</style>